export interface GetProjectsResult extends Array<Item> {}

interface Item {
  _id: number
  name: string
  numberOfApartments: number
  evaluationDate: string
  creationDate: string
  createdBy: CreatedBy
  __v: number
  housingCorporations: string[]
  archived: boolean
  usersInvolved: {_id: string; archived: boolean; name: string}[]
}

interface CreatedBy {
  _id: string
  name: string
}

export type GetProjectsQuery = {
  limit: number
  offset: number
  userId?: string
  customerName?: string
  projectName?: string
  numberOfApartments?: string
  numberOfHousingCorporations?: string
  order?: {
    column:
      | 'projectName'
      | 'customerName'
      | 'numberOfApartments'
      | 'numberOfHousingCorporations'
      | 'creationDate'
      | 'evaluationDate'
    desc: boolean
  }
}

export default function getProjects(
  {get}: any,
  query: GetProjectsQuery,
): Promise<GetProjectsResult> {
  let url = `/projects?limit=${query.limit}&skip=${query.offset}`
  if (typeof query.userId === 'string') {
    url += `&userId=${query.userId}`
  }
  if (
    typeof query.customerName === 'string' &&
    query.customerName.trim().length > 0
  ) {
    url += `&customerName=${encodeURIComponent(query.customerName)}`
  }
  if (
    typeof query.projectName === 'string' &&
    query.projectName.trim().length > 0
  ) {
    url += `&projectName=${encodeURIComponent(query.projectName)}`
  }
  if (
    typeof query.numberOfApartments === 'string' &&
    query.numberOfApartments.trim().length > 0
  ) {
    const theInt = parseInt(query.numberOfApartments.trim(), 10)
    if (theInt > 0 && theInt < 5000) {
      url += `&numberOfApartments=${encodeURIComponent(
        query.numberOfApartments,
      )}`
    }
  }
  if (
    typeof query.numberOfHousingCorporations === 'string' &&
    query.numberOfHousingCorporations.trim().length > 0
  ) {
    const theInt = parseInt(query.numberOfHousingCorporations.trim(), 10)
    if (theInt > 0 && theInt < 5000) {
      url += `&numberOfHousingCorporations=${encodeURIComponent(
        query.numberOfHousingCorporations,
      )}`
    }
  }
  if (query.order) {
    url += `&orderBy=${query.order.column}&orderSort=${
      query.order.desc ? 'asc' : 'desc'
    }`
  }

  url += '&noop=noop'

  return get(url, {}, {retryOn401: true})
}

export const tempGetProjects = (query: {
  limit: number
  offset: number
  userId?: number
}): {list: GetProjectsResult; total: number} => {
  const fullList = require('./tempList.json') as Array<Item>

  const sorted = [...fullList]
  sorted.sort((a, b) => (a.archived ? 1 : -1))

  // debugger

  const filtered = !query.userId
    ? sorted
    : sorted.filter(r => !!r.usersInvolved.find(u => u._id == query.userId))

  const sub = filtered.slice(query.offset, query.offset + query.limit)

  return {list: sub, total: filtered.length}
}



// WEBPACK FOOTER //
// ./src/api/endpoints/projects/getProjects.tsx